
import { useContext, useEffect, useState } from 'react'



import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { CategoriesContext } from '../../context/category/CategoryContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';



export const CategoryPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { createCategory, updateCategory } = useContext(CategoriesContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');

    var category;

    if (state) {
        category = state.category;
    } else {
        category = {
            id: -1,
            name: ''
        }
    }

    const { formState, onInputChange } = useForm(category);

    const { id, name } = formState

    const handleSave = async () => {
        if (!name || name.length === 0) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return false;
        }

        var resp = "";
        if (id > 0) {
            resp = await updateCategory(formState);
        } else {
            resp = await createCategory(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Categoría actualizada correctamente" : "Categoría creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>

            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar categoría' : 'Crear categoría'}</h3>
                <hr />

                <form className="row g-3 " >

                    <div className="mb-3">
                        <label htmlFor="categoryNameInput" className="form-label">Nombre *</label>
                        <input
                            id='categoryNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre de la categoría"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }

        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
